import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Network.svg",
  "use": "Network.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Network.svg\"><path d=\"M54.0208,34.0208h-8v6h3a3,3,0,0,1,3,3v8a3,3,0,0,1-3,3h-10a3,3,0,0,1-3-3v-8a3,3,0,0,1,3-3h3v-6h-20v6h3a3,3,0,0,1,3,3v8a3,3,0,0,1-3,3h-10a3,3,0,0,1-3-3v-8a3,3,0,0,1,3-3h3v-6h-8a2,2,0,0,1,0-4h20v-6h-3a3,3,0,0,1-3-3v-8a3,3,0,0,1,3-3h10a3,3,0,0,1,3,3v8a3,3,0,0,1-3,3h-3v6h20a2,2,0,0,1,0,4Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol